import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Badge, Button, Link, Image } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { DataManager } from '../../../core/data-manager';
import { ResourceManager } from '../../../core/resource-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import banner from '../../../assets/home_eventi.png';
import logo from '../../../assets/logo_fedespedi.svg'
import CardEvento from '../../Card/Evento';
import CardEventoV2 from '../../Card/EventoV2';
import moment from 'moment';



export default function HomeEventi() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);
    const [event, setEvent] = useState(null);
    const [categorie, setCategorie] = useState(null);
    const isMobile = window.innerWidth < 768;


    useEffect(() => {
        getEvent();
        getCategorie();
    }, []);



    async function getEvent() {
        let constraints = [{
            "fieldName": "startDatetime",
            "type": "greater",
            "value": moment().format('YYYY-MM-DD')
        }, {
            "fieldName": "type",
            "type": "value",
            "value": 'evento'
        }, {
            "fieldName": "public",
            "type": "value",
            "value": 1
        }]
        var sorting = {
            'field': 'startDatetime',
            'order': 'asc'
        }
        var resEvent = await DataManager.searchItems('event', 1, 3, sorting, '', [], constraints);
        console.log(resEvent)
        if (resEvent.success === 1) {
            setEvent(resEvent.body)
        }
    }


    async function getCategorie() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var resCat = await DataManager.getItems('category', 1, 100, sorting);
        console.log(resCat)
        if (resCat.success === 1) {
            setCategorie(resCat.body)
        }
    }


    return (
        <Container fluid style={{ backgroundColor: '#f7f7f8' }} >
            <Container fluid={'md'} className='py-5' >

                <Row>
                    <Col md={6} xs={12} className='mb-5'>
                        <h3 style={isMobile ? { color: 'var(--primary-color)', fontSize: '40px' } : { color: 'var(--primary-color)' }} className='mb-3'>Seminari</h3>
                        <h6 className='mb-3' style={{ color: 'var(--primary-color)' }}>Resta aggiornato ovunque tu sia</h6>
                        {categorie && categorie.map((categoria, i) => {
                            return (<Button key={i} className='px-3 me-3 mb-3' style={{ borderRadius: '20px', borderColor: 'white', backgroundColor: 'var(--primary-color)' }} onClick={() => navigate('/ricerca?type=2&category=' + categoria.id)}>{categoria.name}</Button>)
                        })}
                        <Button className='px-3 me-3 mb-3' style={{ borderRadius: '20px', borderColor: 'var(--primary-color)', backgroundColor: 'white', color: 'var(--primary-color)' }} onClick={() => navigate('/eventi')}>Tutti i seminari <FontAwesomeIcon icon='arrow-right'></FontAwesomeIcon></Button>
                    </Col>
                    <Col md={6} xs={12} className='text-center mb-5' style={isMobile ? { display: 'none' } : {}}>
                        <Image src={banner} style={{ width: '100%' }}></Image>
                    </Col>
                </Row>
                {event && event.length > 0 ? <Row>
                    <Col md={12} xs={12}>
                        <h4 style={{ color: 'var(--primary-color)' }}>I prossimi appuntamenti</h4>
                        <Row>
                            {event && event.map((item, i) => {
                                return (<Col md={4} xs={12}>
                                    <CardEventoV2 key={i} data={item}></CardEventoV2>
                                </Col>)
                            })}
                            {event && event.length === 0 ? 'Nessun evento disponibile' : null}
                        </Row>
                    </Col>
                </Row> : null}

            </Container>
        </Container>
    );

};